import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, colores, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import BarraBotones   from '../../components/Barra_menu';
import {withStyles} from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import DialogContent          from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {virtual} from '../../components/VirtualListBox';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '../../components/Select';
import Divider from '@material-ui/core/Divider';
import {Table, TableTreeColumn, TableHeaderRow, TableFixedColumns, TableSelection, TableFilterRow} from '@devexpress/dx-react-grid-material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import {createStore} from 'redux';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import PersonIcon from '@material-ui/icons/Person';
import VideocamIcon from '@material-ui/icons/Videocam';
import PrintIcon from '@material-ui/icons/Print';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Reporte  from '../../components/Modalreporte';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Fade from '@material-ui/core/Fade';
import CheckIcon from '@material-ui/icons/Check';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let planes = [];
let checkId = undefined;
let checkIdCo = undefined;
let refreshOferta = false;

const styles = theme => ({
  
paperCorrequisito: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '1024px' : undefined, 
  maxWidth: !movil ? '1024px' : undefined,
  minHeight: !movil ? '570px' : undefined, 
  maxHeight: !movil ? '570px' : undefined,
},
paperDetalle: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '700px' : undefined, 
  maxWidth: !movil ? '700px' : undefined,
  minHeight: !movil ? '420px' : undefined, 
  maxHeight: !movil ? '420px' : undefined,
},  
paperConfirmation: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},	
paperListaEspera: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '340px' : window.innerWidth < window.innerHeight ? window.innerWidth - 20 + 'px' : window.innerHeight - 20 + 'px', 
  maxWidth: '340px !important',
},	
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
container: {
  display: 'flex',
  justifyContent: !movil ? 'center' : undefined, 
  alignItems: "center",
  flexDirection: !movil ? "row" : "column",
  paddingTop: "2px",
  paddingBottom: "5px", 
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1)
},
textField: {
  marginRight: !movil ? theme.spacing(1) : undefined   
},
inputCheck: {  
  marginLeft: '31px', 
  marginTop: '0px',  
},
tooltip: {
  maxWidth: !movil ? 'none' : undefined,
},
formControlSelect: {
  width: movil ? '100%' : '430px', 
  marginLeft: !movil ? theme.spacing(1) : undefined, 
  textAlign: 'left',
},
labelTime: {
  position: 'absolute',
  right: theme.spacing(4.5),
  top: theme.spacing(1.3),
  color: theme.palette.grey[500],
  fontSize: 12
}

});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns= [
  { name: 'ROOT_TREE', title: ' '  },
  { name: 'ID_SECCION', title: 'ID_SECCION' },
  { name: 'CODIGO_CURSO', title: 'Código' },
  { name: 'DESCRIPCION_CURSO', title: 'Descripción' },
  { name: 'CREDITOS', title: 'Uv' },
  { name: 'DIAS', title: 'Dias' },
  { name: 'INICIO', title: 'Desde' },
  { name: 'FIN', title: 'Hasta' },
  { name: 'AULA', title: 'Aula' },
  { name: 'NUMERO_SECCION', title: 'Sección' },
  { name: 'MODALIDAD', title: 'Grupo' },
  { name: 'PERIODO', title: 'Período' },
  { name: 'DISPONIBLE', title: 'Cupos' }, 
  { name: 'ID_PLAN', title: 'ID_PLAN' },
  { name: 'ESTATUS_FINANCIERO', title: 'Financiero' },
  { name: 'NOMBRE_COMPLETO', title: 'Catedrático' },
  { name: 'GRUPO', title: 'Grupo' },
  { name: 'OPTATIVA', title: 'OPTATIVA' },
  { name: 'TREE', title: ' ' },
];
const columnExtensions = [
  { columnName: 'ROOT_TREE', width: 100 },
  { columnName: 'CODIGO_CURSO', width: widthTable * 0.06 },
  { columnName: 'DESCRIPCION_CURSO', width: !movil ? widthTable * 0.16 : 280}, 
  { columnName: 'CREDITOS', width: widthTable * 0.05, align: 'center'},
  { columnName: 'DIAS', width: widthTable * 0.06, align: 'center'}, 
  { columnName: 'INICIO', width: widthTable * 0.06, align: 'center'},
  { columnName: 'FIN', width: widthTable * 0.06, align: 'center'},    
  { columnName: 'AULA', width: widthTable * 0.06, align: 'center'},    
  { columnName: 'NUMERO_SECCION', width: widthTable * 0.05, align: 'center'},   
  { columnName: 'MODALIDAD', width: widthTable * 0.06, align: 'center'},  
  { columnName: 'DISPONIBLE', width: widthTable * 0.06, align: 'center'},      
  { columnName: 'NOMBRE_COMPLETO', width: !movil ? widthTable * 0.13 : 250},
  { columnName: 'ID_SECCION', width: 0 },
  { columnName: 'ID_PLAN', width: 0 },
  { columnName: 'ESTATUS_FINANCIERO', width: 100 },
  { columnName: 'GRUPO', width: 0 },
  { columnName: 'OPTATIVA', width: 0 },
  { columnName: 'TREE', width: 0 }, 
  { columnName: 'PERIODO', width: 0 },
];
const grouping = [{ columnName: 'ID_PLAN' }, { columnName: 'PERIODO' }];

const columnsCorreq= [
  { name: 'ID_SECCION', title: 'ID_SECCION' },
  { name: 'CODIGO_CURSO', title: 'Código' },
  { name: 'DESCRIPCION_CURSO', title: 'Descripción' },
  { name: 'DIAS', title: 'Dias' },
  { name: 'INICIO', title: 'Desde' },
  { name: 'FIN', title: 'Hasta' },
  { name: 'AULA', title: 'Aula' },
  { name: 'NUMERO_SECCION', title: 'Sección' },
  { name: 'MODALIDAD', title: 'Grupo' },
  { name: 'DISPONIBLE', title: 'Cupos' },
  { name: 'NOMBRE_COMPLETO', title: 'Catedrático' },
];
const columnExtensionsCorreq = [
  { columnName: 'CODIGO_CURSO', width: 60 },
  { columnName: 'DESCRIPCION_CURSO', width: 230 }, 
  { columnName: 'DIAS', width: 60, align: 'center'}, 
  { columnName: 'INICIO', width: 80, align: 'center'},
  { columnName: 'FIN', width: 80, align: 'center'},    
  { columnName: 'AULA', width: 70, align: 'center'},    
  { columnName: 'NUMERO_SECCION', width: 64, align: 'center'}, 
  { columnName: 'MODALIDAD', width: 75, align: 'center'},   
  { columnName: 'DISPONIBLE', width: !movil ? 75 : 100, align: 'center'},      
  { columnName: 'NOMBRE_COMPLETO', width: !movil ? 110 : 180},
];

const columnsDetalle=[
  { name: 'DESCRIPCIÓN', title: 'Descripción' },
  { name: 'FECHA DE PAGO', title: 'Fecha de pago' },
  { name: 'MONTO', title: 'Monto' },
];
const columnExtensionsDetalle = [
  { columnName: 'DESCRIPCIÓN', width: 400 },
  { columnName: 'FECHA DE PAGO', width: 110, align: 'center' },
  { columnName: 'MONTO', width: 110, align: 'right' },
];

const columnsLE = [
  { name: 'DESCRIPCION_CURSO', title: 'Descripción' },
  { name: 'DIAS', title: 'Dias' },
  { name: 'INICIO', title: 'Desde' },
  { name: 'FIN', title: 'Hasta' },
  { name: 'AULA', title: 'Aula' },
  { name: 'POSICION_LE', title: 'Posición' },
  { name: 'MODALIDAD', title: 'Grupo' },
  { name: 'CONCEPTO', title: 'Concepto' },
];
const columnExtensionsLE = [
  { columnName: 'DESCRIPCION_CURSO', width: 280 }, 
  { columnName: 'DIAS', width: 65, align: 'center'}, 
  { columnName: 'INICIO', width: 80, align: 'center'},
  { columnName: 'FIN', width: 80, align: 'center'},    
  { columnName: 'AULA', width: 70, align: 'center'},    
  { columnName: 'POSICION_LE', width: 65, align: 'center'}, 
  { columnName: 'MODALIDAD', width: 100, align: 'center'},  
  { columnName: 'CONCEPTO', width: 200 },
];

const RowId = row => String(row.ID_SECCION);
const ChildRows = (row, rootRows) => (row ? row.TREE : rootRows);
const GroupCellContent = ({ column, row }) => {
  const infoPLan = planes.find(x => x.ID_PLAN === row.value);
  return(
  <span>    
    <strong> {column.name === 'ID_PLAN' ? (infoPLan !== undefined ? infoPLan.DESCRIPCION_NIVEL : " ") : 'Período ' + row.value} </strong> 
  </span>
  );

}
const VirtualTable_cellComponent = (classTooltip) => (props) => {  

  const style={ color: props.row.CHECKED || props.row.CHECKED === 1 ? colores.azul : undefined, 
                fontWeight: props.row.HDR === 1 || props.row.OPTATIVA === 1 ? 'bold' : undefined,
                paddingTop: props.row.HDR === 1 || props.row.OPTATIVA === 1 ? 0 : undefined, 
                paddingBottom: props.row.HDR === 1 || props.row.OPTATIVA === 1 ? 0 : undefined}

  if (props.column.name === 'INICIO')
  {
    return ( <Table.Cell style={style} {...props}>
              { props.row.INICIO !== null ? funciones.getTime(props.row.INICIO, 1) : null }
             </Table.Cell>);
  }
     
  if (props.column.name === 'FIN')
  {
    return ( <Table.Cell style={style} {...props}>
             { props.row.FIN !== null ? funciones.getTime(props.row.FIN, 1) : null }
            </Table.Cell>);
  }
        
  if (props.column.name === 'DISPONIBLE')
  { 
     const colorIconChecked = colores.naranja;
     const _styleCell = {...style, paddingTop: 0, paddingBottom: 0}
     const styleIco = { color: (props.row.CHECKED === 1 || props.row.CHECKED) ? colorIconChecked : colores.color_disabled} 
     const styleDiv = { display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2px", maxHeight: "100%", width: "100%" }; 
     const styleIcoHibridaPre = { color: (props.row.CHECKED === 1 || props.row.CHECKED) ?
                                        (props.row.AUTONOMA === 2 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) ? colorIconChecked
                                        : colores.color_disabled
                                       : colores.color_disabled }
     const styleIcoHibridaPmv = { color: (props.row.CHECKED === 1 || props.row.CHECKED) ?
                                        (props.row.AUTONOMA === 2 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) ? colorIconChecked
                                        : colores.color_disabled
                                      : colores.color_disabled }

    if (props.tableRow.row.ID_ESTADO_MODALIDAD === 2){
      
     return (<Table.Cell style={_styleCell} {...props}>
             <div style={styleDiv}>
             {props.row.AUTONOMA === 2 ? props.row.DISPONIBLE_MODALIDAD : props.row.DISPONIBLE}
             <Tooltip title="Cupos en Presencial" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
              <PersonIcon style={styleIcoHibridaPre} fontSize="small"/>
             </ Tooltip>
             {"  |  " + (props.row.AUTONOMA === 2 ? props.row.DISPONIBLE : props.row.DISPONIBLE_MODALIDAD)}
             <Tooltip title="Cupos en Por Videoconferencia" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
              <VideocamIcon style={styleIcoHibridaPmv} fontSize="small"/>
             </ Tooltip>
             </ div>
            </Table.Cell>);

    }

    if ((props.tableRow.row.ID_ESTADO_MODALIDAD === 1 && props.tableRow.row.AUTONOMA === 1) || (props.tableRow.row.ID_ESTADO_MODALIDAD === 3 && props.tableRow.row.AUTONOMA === 2)){
        return (<Table.Cell style={_styleCell} {...props}>
                 <div style={styleDiv}>
                 {props.row.DISPONIBLE}
                 <Tooltip title="Cupos en Presencial" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
                    <PersonIcon style={styleIco} fontSize="small"/>
                 </ Tooltip>
                 </div>
                </Table.Cell>);
    }

    if ((props.tableRow.row.ID_ESTADO_MODALIDAD === 1 && props.tableRow.row.AUTONOMA === 2) || (props.tableRow.row.ID_ESTADO_MODALIDAD === 3 && props.tableRow.row.AUTONOMA === 1)){
      return (<Table.Cell style={_styleCell} {...props}>
               <div style={styleDiv}>
               {props.row.DISPONIBLE}
              <Tooltip title="Cupos en Por Videoconferencia" placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}}>
               <VideocamIcon style={styleIco} fontSize="small"/>
              </ Tooltip>
              </div>
             </Table.Cell>);
    }


  }

  if (props.column.name === 'NUMERO_SECCION' && props.row.HDR === 0 && props.row.OPTATIVA !== 1 && props.row.ESTATUS_FINANCIERO !== undefined && ((props.row.ESTATUS_FINANCIERO !== null && props.row.ESTATUS_FINANCIERO.length > 0) || !funciones.isEmpty(props.row.GRUPO)))
  {  
     var estado = props.row.ESTATUS_FINANCIERO === "T" ? "Prematriculado" : 
                    props.row.ESTATUS_FINANCIERO === "P" ? "Matriculado" :
                    props.row.ESTATUS_FINANCIERO === "W" ? "En lista de espera" :
                    props.row.ESTATUS_FINANCIERO === "X" ? "Congelado" : "Desconocido";
        estado = props.row.ID_ESTADO_MODALIDAD === 2 ? 
                  (props.row.AUTONOMA === 2 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) ? estado + " (Presencial)" :  
                  (props.row.AUTONOMA === 2 && (props.row.HIBRIDA !== 1 && !props.row.HIBRIDA)) || (props.row.AUTONOMA === 1 && (props.row.HIBRIDA === 1 || props.row.HIBRIDA)) ? estado + " (Por Videoconferencia)" : estado
                 : estado;

     var title = props.row.ESTATUS_FINANCIERO !== null && props.row.ESTATUS_FINANCIERO.length > 0 ? "Estado\n" + estado : "";  
         title = title + (title.length > 0 && !funciones.isEmpty(props.row.GRUPO) ? "\n\n" : "") + (!funciones.isEmpty(props.row.GRUPO) ? "Grupo\n" + props.row.GRUPO : "");
         
    return (<Table.Cell style={{ ...style, position: "relative" }} {...props}>
              <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{title}</ span>} placement="top" classes={{ tooltip: classTooltip }} PopperProps={{style:{zIndex:500000}}} arrow>
                <MoreHorizIcon fontSize="small" style={{ position: "absolute", top: 0, right: 10, color: colores.color_disabled, cursor: "default" }} onClick={(e)=> e.stopPropagation()}/>
              </Tooltip>
              <span>{props.row.NUMERO_SECCION}</span>
            </Table.Cell>);
  }

  if (props.column.name === "CREDITOS" && props.row.HDR === 1)
  { 
    return (<Table.Cell style={style} {...props}>
            <span>{null}</span> 
            </Table.Cell>);
  }

  return (<Table.Cell style={style} {...props}/>);
       
 }
const TableTreeColumn_cellComponent = (estado, checkId) => ({children, style, ...props}) => {
        
  const newChildren = React.Children.map(children, (child, index) => {
    
    if (index === 0){
      return React.cloneElement(child, { 
        ...child.props,
        level: (child.props.level === 1 && props.row.HDR === 0) ? 0 : child.props.level === 2 ? 1 : child.props.level
      });
    }

   if (index === 2){
    return (
      props.row.HDR === 1 || props.row.OPTATIVA === 1?
      <Checkbox icon={<span style={{ width: 0, height: 0 }} />} checkedIcon={<CheckIcon/>} disabled checked={(props.row.CHECKED || (props.row.CHECKED===1))}/>
      :
      React.cloneElement(child, { 
      ...child.props,
      disabled: (props.row.OPTATIVA === 1 || 
                 (props.row.ESTATUS_FINANCIERO !== "T" && props.row.ESTATUS_FINANCIERO !== "W" && props.row.ESTATUS_FINANCIERO !== null && props.row.ESTATUS_FINANCIERO.length > 0)) || 
                  props.row.HDR === 1
                 ? true : false
    })
    );
   }

   return child;
  });

  if (props.row.ROOT_TREE === "..." || (estado && String(props.row.ID_SECCION) === checkId))
  {  
    return (<TableTreeColumn.Cell style={{ ...style, paddingLeft: props.row.ROOT_TREE !== "..." ? newChildren[0].props.level === 0 ? "37px" : "62px" 
                                                                                                    : undefined, 
                                  paddingRight: 0}} 
                                  {...props}>
                <CircularProgress size={22} color="secondary"/>
             </ TableTreeColumn.Cell>) 
  }
  
  return (<TableTreeColumn.Cell children={newChildren} style={style} {...props}/>)
  
}
const HeaderRowCellComponent = (valueStudent, handleResumen, handleListaEspera, handleDetalle, countLE)=>  ({resizingEnabled, ...props}) => {
 
  const style={paddingTop: props.column.name === "ROOT_TREE" ? "5px" : undefined, paddingBottom: props.column.name === "ROOT_TREE" ? "5px" : undefined }
  const disabled = tokenInfo.plataforma === 1 && valueStudent === null ? true : false;

  if (props.column.name === "ROOT_TREE")
  {  
    return (<TableHeaderRow.Cell style={{...style, left: 0}} resizingEnabled={false} {...props}>
             <Tooltip title={!disabled ? "Lista de espera" : ""}>
              <IconButton style ={{ left: -100 }} size="small" onClick={handleListaEspera} disabled={disabled}>
               <Badge color="error" badgeContent={countLE} variant="dot">
                <HowToRegIcon style={{ color: !disabled ? colores.tabla.color_iconos : colores.tabla.color_iconos_SL }} />
               </Badge>
              </IconButton>
             </Tooltip>
             <Tooltip title={!disabled ? "Resumen de matricula" : ""}>
              <IconButton style ={{ left: -84 }} size="small" onClick={handleResumen} disabled={disabled}>
                <PrintIcon style={{ color: !disabled ? colores.tabla.color_iconos : colores.tabla.color_iconos_SL }} />
              </IconButton>
             </Tooltip>
             <Tooltip title={!disabled ? "Detalle a pagar" : ""}>
              <IconButton style ={{ left: -68 }} size="small" onClick={handleDetalle} disabled={disabled}>
                <CreditCardIcon style={{ color: !disabled ? colores.tabla.color_iconos : colores.tabla.color_iconos_SL }} />
              </IconButton>
             </Tooltip>
            </ TableHeaderRow.Cell>
           );
  }

  return (<TableHeaderRow.Cell style={style} resizingEnabled={resizingEnabled} {...props} />);

}
const reducer = (state, action) => {

if (action.type === "SET_OPTATIVAS")
{
  return {
    ...state,
    rows: action.current_rows.map(item => {            
            if (String(item.ID_SECCION) === action.id_seccion) {
              return {...item, TREE: action.rows_optativas } 
            };
            return item;
          }),
   }

}   

return state;

}
const ColumnFixed_cellComponent = (classes, handleChangeCheck, valueFilterCheck) => ({showLeftDivider, showRightDivider, ...props}) => { 
  
  if (props.tableRow.key === "Symbol(filter)" && props.tableColumn.column.name === 'ROOT_TREE')
  { 
     return (<TableFixedColumns.Cell  
              style={{ backgroundColor: 'white', paddingTop: 0, paddingBottom: 0, paddingLeft: 3 }}
              others={{ inputCheck: classes.inputCheck, handleChangeCheck: handleChangeCheck, valueFilterCheck: valueFilterCheck }}
              {...props} 
          />);

  }
 
   return (<TableFixedColumns.Cell 
            style={{ backgroundColor: 'inherit', paddingTop: 0, paddingBottom: 0 }}
            showRightDivider={false}
            showLeftDivider={false}
            {...props} 
        />);

}
const FilterCellComponent = ({children, filteringEnabled, onFilter, getMessage, others, ...props})=>{ 
  
  if (props.column.name === "ROOT_TREE"){
    return (<Table.Cell style={{ paddingTop: 0, paddingBottom: 0 }} {...props}>
             <Checkbox
              checked={others.valueFilterCheck === undefined ? false : others.valueFilterCheck} 
              onChange={others.handleChangeCheck}                 
              value="filterCheck"
              indeterminate = {others.valueFilterCheck === undefined ? true : false }
              className={others.inputCheck}
              indeterminateIcon = {<IndeterminateCheckBoxOutlinedIcon />}
              style={{width: 28, height: 28}}
            />
            </Table.Cell>);
  }

  return (<TableFilterRow.Cell children={children} 
                               getMessage={getMessage}
                               filteringEnabled={filteringEnabled}
                               onFilter={onFilter}
                               {...props} />);
}
const TableSelectionCellComponent = (estado, checkId, disabledChecks) => ({style, ...props}) =>{
  
  if (estado && String(props.row.ID_SECCION) === checkId)
  {
   return ( <Table.Cell style={{ ...style, paddingLeft: '21px', paddingTop: "2px", paddingBottom: "0px" }} {...props}>
             <CircularProgress size={22} color="secondary"/>
           </Table.Cell> 
          );
  }  
  
  if (disabledChecks)
  {
    return(
          <Table.Cell style={{ ...style, paddingBottom: '0px', paddingTop: '0px', paddingRight: '0px', paddingLeft: '12px' }} {...props}>
              <Checkbox disabled checked={props.row.CHECKED} />
          </Table.Cell>
          );
  }
    
  return ( <TableSelection.Cell style={style} {...props}/>);
}
const VirtualTableDetalle_cellComponent = ({value, ...props})=>{

  if (props.column.name === "MONTO")
  {
    return (<Table.Cell value={funciones.formatCurrency(value)} {...props}/>);
  }

  return (<Table.Cell value={value} {...props}/>);

}
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
   <ListItemAvatar style={{ minWidth: 32 }}>
    <Avatar style={{ height: 23, width: 23 }}>
     <PersonIcon size="small"/>
    </Avatar>
   </ListItemAvatar>
  <div style={{ minWidth: "55px", color: "gray" }}>{option.CUENTA_ALUMNO}</ div>
  <div>{option.NOMBRE_COMPLETO}</div>
 </ div>
);

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();
tablaCorreqRef = React.createRef();
dialogActionRef = React.createRef();
dialogActionDetalleRef = React.createRef();
tablaDetalleRef = React.createRef();
tablaLERef = React.createRef();
dialogActionLERef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: false,
       rows: [],
       openBackDrop: false,
       messageBackdrop: "",
       transitionDurationBackdrop: undefined,
       optionAutocomplete: [],
       loadingClientes: true,
       openAutoComplete: false,
       valueAutoComplete: null,
       selectedModPago: '',
       datosSelectModPago: [],
       openBackDropInvisible: false,
       expandedGroup: [],
       loadingCheck: false,
       expandedGroups: [],
       filters: [],
       filterCheck: undefined,
       expandedRowIds: [],
       selection: [],
       openModalCorrequsito: false,
       rowsCorreq: [],
       loadingCorreq: false,
       heightTableCorreq: 0,
       selectionCorreq: [],
       disabledChecksCo: false,
       openModalListaEspera: false,
       openModalDetalle: false,
       rowsDetalle: [],
       loadingDetalle: false,
       heightTableDetalle: 0,
       showButtomsDirLE: false,
       messageLE: "", 
       openModalHibrida: false,
       cuposHibridaA: 0, 
       cuposHibridaB: 0,
       refHibrida: 0,
       saveOptionsLE: false,
       closeTimeLE: 30,
       rowsLE: [],
       countLE: 0,
       loadingLE: false,
       openModalSeccionesLE: false,
       heightTableLE: 0,
       titleModalHibrida: "",
   };
   this.cuenta= null;
   this.reducerRows = createStore(reducer, { rows: [] });
   this.unsubscribeRows = this.reducerRows.subscribe(() => {
      this.setState({ rows: this.reducerRows.getState().rows });
    });
   this.electivasOpens=[];
   this.settingFilter = [
                          { columnName: 'INICIO',
                              predicate: (value, filter, row) => {
                                      value = value !== null ? funciones.getTime(value, 1) : value; 
                                      return IntegratedFiltering.defaultPredicate(value, filter, row);
                                      },
                          },
                          { columnName: 'FIN',
                              predicate: (value, filter, row) => {
                                      value = value !== null ? funciones.getTime(value, 1) : value; 
                                      return IntegratedFiltering.defaultPredicate(value, filter, row);
                                      },
                          },
                          { columnName: 'ID_PLAN',
                              predicate: (value, filter, row) => { 
                                      if (filter.value.length === 0 || filter.value.find(x => x === value)){
                                        return true;
                                      }
                                      return IntegratedFiltering.defaultPredicate(value, filter, row);
                                      },
                          },
                          { columnName: 'ROOT_TREE',
                            predicate: (value, filter, row) => {
                            filter.operation = 'equal';          
                            
                            if (filter.value === true) {
                              
                              if (row.CHECKED === 1 || row.CHECKED) { 
                                return true;
                              }

                              return false;
                            }
                            else if (filter.value === false)
                            {  
                             
                              let notChecked = false;
                              const id_electiva = String(row.ID_SECCION).split("-")[1];
                              this.state.rows.map((item)=>{

                                  if (item.TREE !== null && (id_electiva === undefined || String(item.ID_SECCION) === id_electiva))
                                  {
                                    item.TREE.map((_item)=>{

                                      if (_item.TREE !== null){
                                        _item.TREE.map((__item)=>{
                                          if (String(__item.ID_SECCION).split("-")[1] === id_electiva && (__item.CHECKED === 1 || __item.CHECKED))
                                          notChecked = true; 

                                          return __item;
                                        });
                                      }

                                      if (_item.CODIGO_CURSO === row.CODIGO_CURSO && (_item.CHECKED === 1 || _item.CHECKED) && row.ROOT_TREE !== "...")
                                        notChecked = true; 

                                      return _item;
                                    });
                                  }

                                  if (item.CODIGO_CURSO === row.CODIGO_CURSO && (item.CHECKED === 1 || item.CHECKED))
                                  notChecked = true; 

                                  return item;
                                });


                              if ((row.CHECKED === 0 || !row.CHECKED) && !notChecked) { 
                                
                                return true; 
                              }
                              
                              return false;

                            }

                             return true;

                           },
                          }, 
                          { columnName: 'CODIGO_CURSO',
                            predicate: (value, filter, row) => {
                              
                            if (this.filterStringChildrens("CODIGO_CURSO", filter.value, row))
                            return true;
                            
                            return IntegratedFiltering.defaultPredicate(value, filter, row);
                            }
                          },
                          { columnName: 'DESCRIPCION_CURSO',
                            predicate: (value, filter, row) => {
                              
                            if (this.filterStringChildrens("DESCRIPCION_CURSO", filter.value, row))
                            return true;
                            
                            return IntegratedFiltering.defaultPredicate(value, filter, row);
                            }
                          },
                        ];
   this.botones_lista_espera=[
                              {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOkLE, display:'auto'},
                              {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseListaEspera, display:'auto', color: 'red'},
                             ];
   this.botones_lista_espera_dir=[
                              {icono: 'Person', toolt: '', nombre: 'Agregar cupo', onclick: this.handleOkCupo, display:'auto', color: 'green'},
                              {icono: 'Check', toolt: '', nombre: 'Lista esp.', onclick: this.handleOkLE, display:'auto'},
                             ];
   this.selectionNewTmp=[];
   this.selectionOldTmp=[];
   this.baseHibridaTmp=null;
   this.baseSelectionHibridaTmp=[];
   this.coHibridaTmp=null;
   this.coSelectionHibridaTmp=[];
   this.selectionCoNewTmp = [];
}

onBlurAutoComplete = ()=>{

  if (this.state.openAutoComplete)
   this.setState({ openAutoComplete: false });    
      
}
  
onChangeInput = (e, value)=>{ 
    
  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoComplete) 
      this.setState({ openAutoComplete: false });
               
    return;
  }
        
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoComplete !== null && value === this.state.valueAutoComplete.CUENTA_ALUMNO + ' | ' + this.state.valueAutoComplete.NOMBRE_COMPLETO)) && this.state.openAutoComplete)
    this.setState({ openAutoComplete: false });
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoComplete)
    this.setState({ openAutoComplete: true });
         
}

onChangeAutocomplete = (event, value) =>{
  
planes = [];
this.electivasOpens=[];
this.setState({ valueAutoComplete: value, 
                openAutoComplete: false, 
                rows: [], 
                datosSelectModPago: [],
                selectedModPago: '',
                expandedRowIds: [], 
                selection: [], 
                expandedGroup: [],
                rowsLE: [],
                countLE: 0,
                filters: [],
                filterCheck: undefined }, ()=>{
      
 if (value === null)
 {
  return;
 }
  
 this.handleChangeCuenta(null);   
      
 });  
  
}

filtersClientes = (value)=>{ 
  
  new Request
   .get(`${globales.ip}/matricula/estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 40000, deadline: 50000, }) 
   .end((err, res) => {
              
     if (err) { 
    
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                  
         window.location.reload();
         return;
                    
       }
        
      this.setState({ optionAutocomplete: [], openAutoComplete: false, loadingClientes: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      });
                
      return;
     }
            
     const rows = JSON.parse(res.text);
     this.setState({ optionAutocomplete: rows, loadingClientes: false }); 
                 
       
});
    
}

onRefresh = ()=>{
  
 this.setState({ loadingClientes: true }, ()=>{ 
   this.filtersClientes('-');
 });
  
}

handleChangeCuenta = (event) => {
    
this.cuenta = (event === null && tokenInfo.plataforma === 2) ? tokenInfo.user : tokenInfo.plataforma === 1 ? this.state.valueAutoComplete.CUENTA_ALUMNO : null;
this.setState({ openBackDropInvisible: true }, ()=>{ 
   
  new Request
   .get(`${globales.ip}/matricula/modalidades_pago/${this.cuenta}/${tokenInfo.user}/${tokenInfo.plataforma}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(1)
   .timeout({ response: 20000, deadline: 50000, }) 
   .end((err, res) => {
              
      if (err) { 
      
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
                  
          window.location.reload();
          return;
                    
        }
            
        this.setState({ datosSelectModPago: [], selectedModPago: '', openBackDropInvisible: false }, ()=>{
          funciones.showToast('e', 'No hay conexión');
        });            
                    
        return;
       }
            
       let modalidades = JSON.parse(res.text); 
         
       if (tokenInfo.plataforma !== 1){
         modalidades = modalidades.filter(x => x.VISIBLE_WEB || x.ID_MODALIDAD_CLIENTE);
         if (modalidades.find(x => x.ID_MODALIDAD_CLIENTE && !x.VISIBLE_WEB))
          modalidades = modalidades.filter(x => x.ID_MODALIDAD_CLIENTE && !x.VISIBLE_WEB);
       }
         
       let items = modalidades.map((datos, i) =>{
                   return <MenuItem value={datos.MOD_PAGO_ID} key={i} >{datos.MOD_PAGO_DESCRIPCION}</MenuItem> 
                   });

       const modalidadSel = modalidades.find(x => x.ID_MODALIDAD_CLIENTE);

       this.setState({ datosSelectModPago: items, 
                       selectedModPago: modalidadSel !== undefined ? modalidadSel.MOD_PAGO_ID : "", 
                       openBackDropInvisible: false,
                       loadingMain: true }, ()=>{ 
         this.obtener_planes(this.cuenta)
         this.obtener_lista_espera(this.cuenta);
         this.obtener_oferta(this.cuenta);  
       });
         
    }); 
  
  });
  
}

obtener_oferta = (cuenta)=>{

  new Request
  .get(`${globales.ip}/matricula/oferta/${cuenta}/${tokenInfo.user}/${tokenInfo.sucursal}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 60000, deadline: 60000, }) 
  .end((err, res) => {
                                  
     if (err) { 
                         
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                                   
         window.location.reload();
         return;
                                        
       }
                              
    this.setState({ rows: [], expandedGroups: [], selection: [], loadingMain: false }, ()=>{
       funciones.showToast('e', 'No hay conexión');
    }); 
                                                  
    return;
   }
                                
   const rowsOferta = JSON.parse(res.text); 
                            
   if (rowsOferta.length > 0)
   {     
                          
     const infoTable = this.formatRows(rowsOferta);          
     this.setState({ rows: infoTable.rows, expandedGroups: infoTable.expandedGroup, selection: infoTable.selection, loadingMain: false });
       
   }
   else 
   {
     this.setState({ rows: [], expandedGroups: [], selection: [], loadingMain: false });
   }            
                            
 });

}

obtener_planes= (cuenta)=>{

new Request
 .get(`${globales.ip}/matricula/planes/${cuenta}/${tokenInfo.plataforma}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 50000, deadline: 50000, }) 
 .end((err, res) => {
                
   if (err) { 
        
    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {
                    
      window.location.reload();
      return;
                      
    }
              
    funciones.showToast('e', 'No hay conexión');
       
    return;
  }
              
  planes = JSON.parse(res.text).filter(x => x.ESTADO.trim() === 'ACTIVO'); 
  
});   

}

changeExpandedGroups = expandedGroups =>
{
  this.setState({ expandedGroups }); 
}

changeSelection = selection =>{ 

  if (funciones.isEmpty(this.state.selectedModPago)){
    funciones.showToast("w", "Es necesario que seleccione una modalidad de pago");
    return;
  }
  
  const selection_original = selection.slice(); 

  let row = funciones.getIdRowChecking(selection, this.state.selection).split("-"); 
  const markAction = selection.length > this.state.selection.length ? true : false;

  checkId = row[1] !== undefined ? row[0] + "-" + row[1] : row[0];

  if (markAction){
   selection.push(this.getIdHdr(row[0], row[1])); 
   if (row[1] !== undefined)
   selection.push(row[1]);
  }
  else{
   selection = selection.filter(x => x !== this.getIdHdr(row[0], row[1]));
   if (row[1] !== undefined)
   selection = selection.filter(x => x !== row[1]);
  }
  
  let rowChecked = this.getInfoRowChecked(checkId); 
  if (rowChecked.ID_ESTADO_MODALIDAD === 2 && this.baseHibridaTmp === null && markAction)
  {
    this.baseSelectionHibridaTmp = selection_original;
    this.setState({ refHibrida: 1,
                    cuposHibridaA: rowChecked.AUTONOMA !== 2 ? rowChecked.DISPONIBLE : rowChecked.DISPONIBLE_MODALIDAD, 
                    cuposHibridaB: rowChecked.AUTONOMA !== 2 ? rowChecked.DISPONIBLE_MODALIDAD : rowChecked.DISPONIBLE, 
                    titleModalHibrida: "Sección híbrida",
                    openModalHibrida: true });
    return;
  }
  
  if (rowChecked.CORREQUISITOS === 1 && markAction)
  { 
    this.selectionNewTmp = selection;
    this.selectionOldTmp = this.state.selection;
    this.setState({ loadingCorreq: true, rowsCorreq: [], selectionCorreq: [], openModalCorrequsito: true }, ()=>{
      this.obtenerSeccionesCorreq(rowChecked.ID_DETALLE_PLAN); 
    });
    return;
  }
  
  this.setState({ loadingCheck: true }, ()=>{
            
    this.gestion_matricula(row[0], 
                           'null', 
                           rowChecked.CODIGO_CURSO,
                           'null', 
                           rowChecked.ID_PLAN, 
                           row[1] !== undefined ? row[1] : 'null', 
                           !markAction && rowChecked.ESTATUS_FINANCIERO === "W" ? 1 : 0, 
                           this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp, 
                           'null', 
                           markAction ? 1 : 2)
    .then((res)=>{
       
      if (res === null){
        this.resetValuesSeccionHibrida();
        return; 
      } 

      if (res[0].RESP === 'OK')
      {       
        this.setState({ selection, loadingCheck: false }, ()=> { 
          if (!markAction && rowChecked.ESTATUS_FINANCIERO === "W") {
            this.setState({ countLE: this.state.countLE - 1 });  
          }
          this.setValuesRow(checkId, true, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD, markAction ? "T" : null, markAction ? this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp : null);              
          funciones.showToast('s', "Ha " + (markAction ? "marcado " : "desmarcado ") + rowChecked.DESCRIPCION_CURSO + " Sección " + rowChecked.NUMERO_SECCION); 
          this.resetValuesSeccionHibrida();
        });     

      }
      else if (res[0].RESP === 'LISTA_ESPERA' && res[0].HABILITADO_LE && markAction){

        this.selectionNewTmp = selection;
        this.setState({ loadingCheck: false, 
                        showButtomsDirLE: res[0].HABILITA_CUPO_DIRECTO, 
                        messageLE: this.getMessageLE(res[0].HABILITA_CUPO_DIRECTO), 
                        closeTimeLE: 30,
                        openModalListaEspera: true }, ()=>{
            this.setValuesRow(checkId, false, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
        });

      }
      else
      {
        this.setState({ loadingCheck: false }, ()=> { 
            this.setValuesRow(checkId, false, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
            funciones.showToast('w', res[0].RESP); 
            this.resetValuesSeccionHibrida();
          });     

      }

     });
     
  });
  
}

changeFilters = filters =>{
  this.setState({ filters });
}

changeExpandedRowIds = expandedRowIds => {

  const row = funciones.getIdRowChecking(expandedRowIds, this.state.expandedRowIds).split("-"); 
  const haveOptativas =  this.state.rows.find(x => String(x.ID_SECCION) === row[0]); 

  if (this.electivasOpens.find(x => x === row[0]) || haveOptativas === undefined || haveOptativas.OPTATIVA === 0){ 
     return this.setState({ expandedRowIds});
   } 

  this.electivasOpens.push(row[0]); 
  this.setState({ expandedRowIds,  openBackDropInvisible: true }, ()=>{
  
   new Request
  .get(`${globales.ip}/matricula/oferta_optativa/${this.cuenta}/${parseInt(row[0])}/${tokenInfo.sucursal}/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 50000, deadline: 40000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
        
        this.electivasOpens = this.electivasOpens.filter(x => x !== row[0]);
        this.setState({ expandedRowIds: this.state.expandedRowIds.filter(x => x !== row[0]), 
                        openBackDropInvisible: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión');
        });
        
       return;
     }
        
     const rows = JSON.parse(res.text);
  
     if (rows.length > 0)
     {  
        const infoTable = this.formatOptativeRows(rows, row[0]);
        this.setOptativas(this.state.rows, infoTable.rows, row[0]);
        this.setState({ selection: infoTable.selection, openBackDropInvisible: false });
     }
     else 
     {  
        this.setOptativas(this.state.rows, null, row[0]);
        this.setState({ openBackDropInvisible: false });
     }            
     
   });

  });
}

setOptativas = (current_rows, rows_optativas, id_seccion)=>{
   
  this.reducerRows.dispatch({
        type: "SET_OPTATIVAS",
        current_rows: current_rows,
        rows_optativas: rows_optativas,
        id_seccion: id_seccion
     });

}

formatRows = (rows)=>{

let parentRows = rows.filter(x => (x.HDR === 1 || x.OPTATIVA === 1));

parentRows.map((item, index)=>{

item.TREE = item.OPTATIVA === 1 ? 
              [{ ROOT_TREE: "...",
                 ID_SECCION: index * -1, 
                 CODIGO_CURSO: null, 
                 DESCRIPCION_CURSO: null, 
                 CREDITOS: null, 
                 DIAS: null, 
                 INICIO: null, 
                 FIN: null,
                 AULA: null, 
                 NUMERO_SECCION: null,  
                 PERIODO: item.PERIODO, 
                 DISPONIBLE: null,  
                 ID_PLAN: item.ID_PLAN, 
                 ESTATUS_FINANCIERO: null, 
                 NOMBRE_COMPLETO: null, 
                 GRUPO: null,
                 OPTATIVA: 0, 
                 CHECKED: item.CHECKED,
                 TREE: null,
                 HDR: 1 }] :
              rows.filter(x => x.CODIGO_CURSO === item.CODIGO_CURSO && x.HDR === 0);

return item;

});

let allGroups = [];
let foundPlan;
let foundPeriodo;
let selection = [];

rows.map((item, index)=>{

  foundPlan = allGroups.find(x => x === item.ID_PLAN.toString());
  if (foundPlan === undefined){
      allGroups.push(item.ID_PLAN.toString());
  }else {
      foundPlan = undefined;
  }

  foundPeriodo= allGroups.find(x => x === item.ID_PLAN + '|' + item.PERIODO);
  if (foundPeriodo === undefined){
     allGroups.push(item.ID_PLAN + '|' + item.PERIODO);
  }else {
    foundPeriodo = undefined;
  }
                             
  if (item.CHECKED)
  {
    selection.push(String(item.ID_SECCION));
  }

  return item;
});

return { rows: parentRows, selection: selection, expandedGroup: allGroups }

}

formatOptativeRows = (rows, idElectiva)=>{

let parentRows = rows.filter(x => (x.HDR === 1));

parentRows.map((item, index)=>{ 

  item.TREE = rows.filter(x => x.CODIGO_CURSO === item.CODIGO_CURSO && x.HDR === 0);

  return item;
});

let selection = this.state.selection; 
       
rows.map((item, index)=>{
  item.ID_SECCION = String(item.ID_SECCION) + "-" + idElectiva;
          
   if (item.CHECKED)
   {
     selection.push(String(item.ID_SECCION));
   }

   return item;
});

return { rows: parentRows, selection: selection }

}

getIdHdr = (id_row, id_electiva)=>{

  let idRowHdr = null;
  
  this.state.rows.map((item)=>{
  
   if (item.TREE !== null && (id_electiva === undefined || String(item.ID_SECCION) === id_electiva)){
  
    item.TREE.map((_item)=>{
  
      if (_item.TREE !== null){
  
        _item.TREE.map((__item)=>{
          if (String(__item.ID_SECCION).split("-")[0] === id_row && _item.HDR === 1 && idRowHdr === null){
            idRowHdr = String(_item.ID_SECCION); 
          }
          return __item;  
        });
  
      }
  
      if (String(_item.ID_SECCION) === id_row && item.HDR === 1 && idRowHdr === null)
      {
        idRowHdr = String(item.ID_SECCION);    
      }
  
      return _item;
    });
    
    }
  
    return item;
  });
  
  return idRowHdr;
  
}

handleChangeCheckFilter = (event) => {
  
  const value = event === null ? this.state.filterCheck
                               : this.state.filterCheck === false ? undefined: event.target.checked;
  let filter =  this.state.filters.filter(x=> x.columnName !== 'ROOT_TREE');
   
  this.setState({ filterCheck: value, 
                  filters: [...filter, {columnName: 'ROOT_TREE', 
                                        operation: 'equal', 
                                        value: value }], 
                  });

}

setValuesRow = (id_row, changeValueCheck, disponible, disponible_mod, estado, hibrida)=>{

this.state.rows.map((item)=>{

  if (item.TREE !== null)
  {
     item.TREE.map((_item)=>{
        
       if (_item.TREE !== null){
          _item.TREE.map((__item)=>{
            if (String(__item.ID_SECCION) === id_row){  
              if (changeValueCheck){
               item.CHECKED = item.CHECKED === 0 ? 1 : 0;
               _item.CHECKED = !_item.CHECKED ? true : false;
               __item.CHECKED = !__item.CHECKED ? true : false;
              }

              __item.DISPONIBLE = disponible !== undefined ? disponible : __item.DISPONIBLE;
              __item.DISPONIBLE_MODALIDAD = disponible_mod !== undefined ? disponible_mod : __item.DISPONIBLE_MODALIDAD;
              __item.ESTATUS_FINANCIERO = estado !== undefined ? estado : __item.ESTATUS_FINANCIERO;
              __item.HIBRIDA = hibrida !== undefined ? hibrida : __item.HIBRIDA;
            }
            return __item;
          });
       }

      if (String(_item.ID_SECCION) === id_row)
      {  
         if (changeValueCheck){
         item.CHECKED = item.CHECKED === 0 ? 1 : 0;
         _item.CHECKED = _item.CHECKED === 0 ? 1 : 0;
         }

         _item.DISPONIBLE = disponible !== undefined ? disponible : _item.DISPONIBLE;
         _item.DISPONIBLE_MODALIDAD = disponible_mod !== undefined ? disponible_mod : _item.DISPONIBLE_MODALIDAD;
         _item.ESTATUS_FINANCIERO = estado !== undefined ? estado : _item.ESTATUS_FINANCIERO;
         _item.HIBRIDA = hibrida !== undefined ? hibrida : _item.HIBRIDA;
      }

      return _item;
     });
  }

  return  item;
}); 
this.handleChangeCheckFilter(null);
}

setCheckedRowCo = (id_row, changeValueCheck, disponible, disponible_mod, hibrida)=>{

this.state.rowsCorreq.map((item)=>{
  
  if (String(item.ID_SECCION) === id_row){
    if (changeValueCheck)
    item.CHECKED = item.CHECKED ? false : true;
    
    item.DISPONIBLE = disponible;
    item.DISPONIBLE_MODALIDAD = disponible_mod;
    item.HIBRIDA = hibrida !== undefined ? hibrida : item.HIBRIDA;
  }

  return item;
});

}

filterStringChildrens = (columnName, filterValue, row)=>{

  let findChild=false;
  
  this.state.rows.map((item)=>{ 

    if (item.TREE !== null)
    {
      item.TREE.map((_item)=>{ 
        
          if (_item.TREE !== null){
            _item.TREE.map((__item)=> { 

              if (item[columnName].toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()) && 
              String(__item.ID_SECCION) === String(row.ID_SECCION)){
                findChild= true;
               }

              return __item;
            });
          }

          if (item[columnName].toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()) && 
              String(_item.ID_SECCION) === String(row.ID_SECCION)){
            findChild= true;
            }
         
        return _item; 
      });

    }
    
    return item;

   });

return findChild;

}

getInfoRowChecked=(id_seccion)=>{

  var row=[];

  this.state.rows.map((item)=>{

    if (item.TREE !== null)
    {
       item.TREE.map((_item)=>{
        
         if (_item.TREE !== null){
            _item.TREE.map((__item)=>{
              if (String(__item.ID_SECCION) === id_seccion){ 
                row=__item;
              }
              return __item;
            });
         }
  
        if (String(_item.ID_SECCION) === id_seccion)
        {  
          row=_item;
        }
  
        return _item;
       });
    }
  
    return  item;
  });

 return row;

}

handleCloseCorrequisito= ()=>{
  checkIdCo = undefined;
  this.selectionNewTmp= [];
  this.selectionOldTmp= [];
  this.selectionCoNewTmp = [];
  this.resetValuesSeccionHibrida();
  this.setState({ openModalCorrequsito: false });
}

obtenerSeccionesCorreq = (id_detalle_plan)=>{

new Request
.get(`${globales.ip}/matricula/oferta_correquisito/${this.cuenta}/${id_detalle_plan}`)
.set({'authorization': 'Bearer ' + Auth.getToken() })
.retry(1)
.timeout({ response: 30000, deadline: 40000, }) 
.end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      this.setState({ rowsCorreq: [], loadingCorreq: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      }); 
       
      return;
   }
      
  const rows = JSON.parse(res.text); 
  
  if (rows.length > 0) 
  { 
    const haveChecked = rows.find(x => x.CHECKED) ? true : false;   
    this.setState({ rowsCorreq: rows, disabledChecksCo: haveChecked, loadingCorreq: false });     
  }
  else 
  {
    this.setState({ rowsCorreq: [], loadingCorreq: false });
  }            
   
});

} 

onEnteringCorrequisito = ()=>{

this.setState({ heightTableCorreq: funciones.getHeightTableDialog(movil, this.tablaCorreqRef, this.dialogActionRef, 3) });

}

changeSelectionCorreq = selectionCorreq =>{
    
  checkIdCo = funciones.getIdRowChecking(selectionCorreq, this.state.selectionCorreq);
  const markAction = selectionCorreq.length > this.state.selectionCorreq.length ? true : false;
   
  let rowChecked = this.getInfoRowChecked(checkId);
  let rowCoChecked = this.state.rowsCorreq.find(x => x.ID_SECCION === parseInt(checkIdCo)); 

  let seccionBase = String(rowChecked.ID_SECCION).split("-");

  if (rowCoChecked.ID_ESTADO_MODALIDAD === 2 && this.coHibridaTmp === null && markAction)
  {
    this.coSelectionHibridaTmp = selectionCorreq;
    this.setState({ refHibrida: 2, 
                    cuposHibridaA: rowCoChecked.AUTONOMA !== 2 ? rowCoChecked.DISPONIBLE : rowCoChecked.DISPONIBLE_MODALIDAD,
                    cuposHibridaB: rowCoChecked.AUTONOMA !== 2 ? rowCoChecked.DISPONIBLE_MODALIDAD : rowCoChecked.DISPONIBLE,
                    titleModalHibrida: "Sección correquisito híbrida",
                    openModalHibrida: true });
    return;
  }

  this.setState({ loadingCheck: true }, ()=>{
  
    this.gestion_matricula(parseInt(seccionBase[0]),
                           rowCoChecked.ID_SECCION, 
                           rowChecked.CODIGO_CURSO, 
                           rowCoChecked.CODIGO_CURSO,
                           rowChecked.ID_PLAN, 
                           seccionBase[1] !== undefined ? seccionBase[1] : 'null', 
                           !markAction && rowChecked.ESTATUS_FINANCIERO === "W" ? 1 : 0, 
                           this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp,
                           this.coHibridaTmp === null ? 0 : this.coHibridaTmp, 
                           markAction ? 3 : 2)
    .then((res)=>{ 

      if (res === null){
        this.resetValuesSeccionHibridaCo();
        return;
      }
        
      if (res[0].RESP === 'OK' && res[0].RESP_CORREQUISITO === 'OK')
      {   
          
          if (markAction){

            this.gestion_matricula(parseInt(seccionBase[0]),
                                  rowCoChecked.ID_SECCION, 
                                  rowChecked.CODIGO_CURSO, 
                                  rowCoChecked.CODIGO_CURSO,
                                  rowChecked.ID_PLAN, 
                                  seccionBase[1] !== undefined ? seccionBase[1] : 'null', 
                                  0, 
                                  this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp,
                                  this.coHibridaTmp === null ? 0 : this.coHibridaTmp, 
                                  1)
            .then((_res)=>{

              if (_res === null){
                this.resetValuesSeccionHibridaCo();
                return;
              } 

              if (_res[0].RESP === 'OK' && _res[0].RESP_CORREQUISITO === 'OK')
              {
                this.setState({selection: this.selectionNewTmp, selectionCorreq, loadingCheck: false }, ()=> {              
                  this.setCheckedRowCo(checkIdCo, true, _res[0].DISPONIBLE_CORREQUISITO, _res[0].DISPONIBLE_MODALIDAD_CORREQUISITO, this.coHibridaTmp === null ? 0 : this.coHibridaTmp);
                  this.setValuesRow(checkId, true, _res[0].DISPONIBLE, _res[0].DISPONIBLE_MODALIDAD, "T", this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp);
                  funciones.showToast('s', "Ha marcado " + rowChecked.DESCRIPCION_CURSO + " Sección " + rowChecked.NUMERO_SECCION);
                  funciones.showToast('s', "Ha marcado " + rowCoChecked.DESCRIPCION_CURSO + " Sección " + rowCoChecked.NUMERO_SECCION);
                  this.resetValuesSeccionHibridaCo();
                }); 

              }
              else
              {
                  this.setState({ loadingCheck: false }, ()=> { 
                    this.setCheckedRowCo(checkIdCo, false, _res[0].DISPONIBLE_CORREQUISITO, _res[0].DISPONIBLE_MODALIDAD_CORREQUISITO);
                    this.setValuesRow(checkId, false, _res[0].DISPONIBLE, _res[0].DISPONIBLE_MODALIDAD);
                    this.resetValuesSeccionHibridaCo();

                    if (_res[0].RESP !== 'OK')
                    return funciones.showToast('w', _res[0].RESP + " (Curso base)"); 
                    
                    funciones.showToast('w', _res[0].RESP_CORREQUISITO + " (Correquisito)")
          
                  });
              }

            });

          }
          else{
     
            this.setState({ selection: this.selectionOldTmp, selectionCorreq, loadingCheck: false}, ()=>{
              if (!markAction && rowChecked.ESTATUS_FINANCIERO === "W") {
                this.setState({ countLE: this.state.countLE - 1 });  
              }
              this.setCheckedRowCo(checkIdCo, true, res[0].DISPONIBLE_CORREQUISITO, res[0].DISPONIBLE_MODALIDAD_CORREQUISITO, null);
              this.setValuesRow(checkId, true, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD, null, null);
              funciones.showToast('s', "Ha desmarcado " + rowChecked.DESCRIPCION_CURSO + " Sección " + rowChecked.NUMERO_SECCION);
              funciones.showToast('s', "Ha desmarcado " + rowCoChecked.DESCRIPCION_CURSO + " Sección " + rowCoChecked.NUMERO_SECCION);
            });
     
          }

        }
        else if (res[0].RESP === 'LISTA_ESPERA' && res[0].HABILITADO_LE && markAction){

          this.selectionCoNewTmp = selectionCorreq;
          this.setState({ loadingCheck: false, 
                          showButtomsDirLE: res[0].HABILITA_CUPO_DIRECTO, 
                          messageLE: this.getMessageLE(res[0].HABILITA_CUPO_DIRECTO) + " (Curso base)", 
                          closeTimeLE: 30,
                          openModalListaEspera: true }, ()=>{
              this.setValuesRow(checkId, false, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
              this.setCheckedRowCo(checkIdCo, false, res[0].DISPONIBLE_CORREQUISITO, res[0].DISPONIBLE_MODALIDAD_CORREQUISITO);

          });
  
        }
        else 
        {
          this.setState({ loadingCheck: false }, ()=> { 
            this.setCheckedRowCo(checkIdCo, false, res[0].DISPONIBLE_CORREQUISITO, res[0].DISPONIBLE_MODALIDAD_CORREQUISITO);
            this.setValuesRow(checkId, false, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
            this.resetValuesSeccionHibridaCo(); 
            
            if (res[0].RESP !== 'OK')
            return funciones.showToast('w', res[0].RESP + " (Curso base)"); 
            
            funciones.showToast('w', res[0].RESP_CORREQUISITO + " (Correquisito)")

          }); 
        }
  

    });
    
    
  });

}

gestion_matricula = async (id_seccion, id_seccion_co, codigo, codigo_co, id_plan, id_detalle_plan, lista_espera, hibrida, hibrida_co, tipo)=>{

 return await new Promise(resolve => {

  new Request
  .post(`${globales.ip}/matricula`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .set('Content-Type', 'application/json')
  .send({ id_seccion: parseInt(id_seccion), 
          id_seccion_co: id_seccion_co,
          codigo_curso: codigo, 
          codigo_curso_co: codigo_co,
          cuenta_alumno: this.cuenta,
          id_plan: id_plan,
          ad_usuario: tokenInfo.user,
          id_cajero: 2,
          id_detalle_plan: id_detalle_plan,
          lista_espera: lista_espera,
          hibrida: hibrida,
          hibrida_co: hibrida_co,
          tipo: tipo,
         })
  .retry(0)
  .timeout({ response: 50000, deadline: 60000, }) 
  .end((err, res) => {
          
    if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
  
        this.setState({ loadingCheck: false, openBackDrop: false }, ()=>{ 
          funciones.showToast('e', 'No hay conexión'); 
        });
    
        return resolve(null);
    }
        
    const rows = JSON.parse(res.text); 
  
    if (rows.length > 0)
    {  
      resolve(rows);
    }     
    
 });

});

}

handleCloseListaEspera = ()=>{
  
  this.setState({ openModalListaEspera: false }, ()=>{
    clearInterval(this.count);
    this.resetValuesSeccionHibridaCo();
    if (!this.state.openModalCorrequsito){
      this.resetValuesSeccionHibrida();
    }
  });

}

handleChangeModPago = (event)=>{

  const id_mod_pago_old = this.state.selectedModPago;
  const id_mod_pago_new = event.target.value; 

  this.setState({ selectedModPago: event.target.value, 
                  transitionDurationBackdrop: { enter: 2000, exit: 500 },
                  messageBackdrop: "Configurando modalidad de pago...",
                  openBackDrop: true }, ()=>{
    
    new Request
     .post(`${globales.ip}/matricula/modalidades_pago/modalidad`)
     .set({'authorization': 'Bearer ' + Auth.getToken() })
     .set('Content-Type', 'application/json')
     .send({ cuenta_alumno: this.cuenta,  
             ad_usuario: tokenInfo.user,
             id_modalidad: id_mod_pago_new })
     .retry(0)
     .timeout({ response: 50000, deadline: 50000, }) 
     .end((err, res) => {
                  
       if (err) { 
        
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
                      
          window.location.reload();
          return;
                        
        }
          
        this.setState({ selectedModPago: id_mod_pago_old, openBackDrop: false }, ()=>{ 
           funciones.showToast('e', 'No hay conexión'); 
        });
                    
        return;
       }
                
       const rows = JSON.parse(res.text); 
          
       if (rows[0].RESP === 'OK')
        this.setState({ openBackDrop: false });     
       else
        this.setState({ selectedModPago: id_mod_pago_old, openBackDrop: false }, ()=>{ 
            funciones.showToast('w', rows[0].RESP); 
        });                    
                              
     });

  });

}

handleResumen = ()=>{
  document.getElementById("BTRM").click();
}

handleDetalle = ()=>{

 this.setState({ openModalDetalle: true });

}

handleCloseDetalle = ()=>{

  this.setState({ openModalDetalle: false });

}

onEnteringDetalle= ()=>{

  this.setState({ heightTableDetalle: funciones.getHeightTableDialog(movil, this.tablaDetalleRef, this.dialogActionDetalleRef, 3), loadingDetalle: true }, ()=>{
    
    new Request
    .get(`${globales.ip}/matricula/modalidades_pago/detalle_pago/${this.cuenta}`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .retry(1)
    .timeout({ response: 40000, deadline: 40000, })
    .end((err, res) => {
            
       if (err) { 
    
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
                
            window.location.reload();
            return;
                  
          }
    
          this.setState({ rowsDetalle: [], loadingDetalle: false }, ()=>{ 
            funciones.showToast('e', 'No hay conexión');
          });
      
          return;
       }
          
       const rows = JSON.parse(res.text); 
    
       if (rows.length > 0)
       {    
         this.setState({ rowsDetalle: rows, loadingDetalle: false });
       }
       else
       {
         this.setState({ rowsDetalle: [], loadingDetalle: false });
       }            
       
      });

  });

}

handleCloseHibrida = ()=>{
  this.setState({ openModalHibrida: false });
}

onClickListItem = (valueHibrida) => async (event)=>{
  
  if (this.state.refHibrida === 1){
    const infoRow = this.getInfoRowChecked(checkId);
    this.baseHibridaTmp = (infoRow.AUTONOMA === 2 && valueHibrida === "PRE") ||
                          (infoRow.AUTONOMA === 1 && valueHibrida === "PMV") ? 1 : 0;
    await Promise.resolve(this.setState({ openModalHibrida: false }));
    this.changeSelection(this.baseSelectionHibridaTmp);
  }

  if (this.state.refHibrida === 2){
    const infoRowCo  = this.state.rowsCorreq.find(x => x.ID_SECCION === parseInt(checkIdCo)); 
    this.coHibridaTmp = (infoRowCo.AUTONOMA === 2 && valueHibrida === "PRE") ||
                        (infoRowCo.AUTONOMA === 1 && valueHibrida === "PMV") ? 1 : 0;
    await Promise.resolve(this.setState({ openModalHibrida: false }));
    this.changeSelectionCorreq(this.coSelectionHibridaTmp);
  }

  
}

resetValuesSeccionHibrida=()=>{
  this.baseHibridaTmp=null;
  this.baseSelectionHibridaTmp=[];
}

resetValuesSeccionHibridaCo = ()=>{
  this.coHibridaTmp=null;
  this.coSelectionHibridaTmp=[];
}

getMessageLE = (director)=>{

  return director ? "Ya no hay cupo disponible en la sección. ¿Qué desea hacer?" : 
          "Ya no hay cupo disponible en la sección. ¿Desea hacer la inscripción en lista de espera hasta que se libere un cupo?";

}

handleOkCupo = ()=>{

clearInterval(this.count);
const rowChecked = this.getInfoRowChecked(checkId); 
const id_seccion = parseInt(rowChecked.ID_SECCION.toString().split("-")[0]);

this.setState({ transitionDurationBackdrop: undefined,
                messageBackdrop: "Procesando...",
                openBackDrop: true, 
                openModalListaEspera: false }, ()=>{ 

  new Request
   .post(`${globales.ip}/matricula/aumentar_cupo`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .set('Content-Type', 'application/json')
   .send({ id_seccion: id_seccion, 
           hibrida: this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp, 
           ad_usuario: tokenInfo.user })
   .retry(0)
   .timeout({ response: 30000, deadline: 40000 }) 
   .end((err, res) => {
                  
      if (err) { 
          
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
                      
         window.location.reload();
         return;
                        
        }
          
        this.setState({ openBackDrop: false }, ()=>{ 
          this.resetValuesSeccionHibridaCo();
          funciones.showToast('e', 'No hay conexión'); 
        });
                
            
        return;
      }
                
      const rows = JSON.parse(res.text);
         
      if (rows.length > 0)
      {    
         if (rows[0].RESP === 'OK') 
         {  
            this.setState({ openBackDrop: false }, ()=> {
              this.setValuesRow(checkId, false, rows[0].DISPONIBLE, rows[0].DISPONIBLE_MODALIDAD);
              this.resetValuesSeccionHibridaCo();
              funciones.showToast('s', 'Se ha incrementado el cupo en la sección'); 
            });     

         }
         else
         { 
           this.setState({ openBackDrop: false }, ()=>{ 
             this.setValuesRow(checkId, false, rows[0].DISPONIBLE, rows[0].DISPONIBLE_MODALIDAD);
             this.resetValuesSeccionHibridaCo();
             funciones.showToast('w', rows[0].RESP);
           });            
         }
      }                  
            
    });

 });

}

handleOkLE = ()=>{

clearInterval(this.count);
const rowChecked = this.getInfoRowChecked(checkId); 
const rowCoChecked = this.state.rowsCorreq.find(x => x.ID_SECCION === parseInt(checkIdCo));
const row = rowChecked.ID_SECCION.toString().split("-");

this.setState({ transitionDurationBackdrop: undefined,
                messageBackdrop: "Procesando...",
                openBackDrop: true, 
                openModalListaEspera: false }, ()=>{ 

  this.gestion_matricula(parseInt(row[0]),
                         checkIdCo === undefined ? 'null' : rowCoChecked.ID_SECCION,
                         rowChecked.CODIGO_CURSO,
                         checkIdCo === undefined ? 'null' : rowCoChecked.CODIGO_CURSO,
                         rowChecked.ID_PLAN,
                         row[1] !== undefined ? row[1] : 'null',
                         1,
                         this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp,
                         this.coHibridaTmp === null ? 0 : this.coHibridaTmp,
                         1)
  .then((res)=>{ 

    if (res === null){
      if (checkIdCo === undefined){
        this.resetValuesSeccionHibrida();
      }
      this.resetValuesSeccionHibridaCo();
      return; 
    } 
    
    if (res[0].RESP === 'OK' && (checkIdCo === undefined || (checkIdCo !== undefined && res[0].RESP_CORREQUISITO === 'OK')))
    { 
       this.setState({ selection: this.selectionNewTmp,
                       selectionCorreq: checkIdCo === undefined ? this.state.selectionCorreq : this.selectionCoNewTmp,
                       countLE:  this.state.countLE + 1,  
                       openBackDrop: false }, ()=>{

        this.setValuesRow(checkId, true, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD, "W", this.baseHibridaTmp === null ? 0 : this.baseHibridaTmp);
        if (checkIdCo !== undefined){
          this.setCheckedRowCo(checkIdCo, true, res[0].DISPONIBLE_CORREQUISITO, res[0].DISPONIBLE_MODALIDAD_CORREQUISITO, this.coHibridaTmp === null ? 0 : this.coHibridaTmp);
        }
        if (checkIdCo === undefined){
          this.resetValuesSeccionHibrida();
        }
        this.resetValuesSeccionHibridaCo();
        funciones.showToast('s', "Se registró en lista de espera para " + rowChecked.DESCRIPCION_CURSO + " sección " + rowChecked.NUMERO_SECCION);
                
       });
    }
    else 
    {
      this.setState({ openBackDrop: false }, ()=>{
        this.setValuesRow(checkId, false, res[0].DISPONIBLE, res[0].DISPONIBLE_MODALIDAD);
        if (checkIdCo !== undefined){
          this.setCheckedRowCo(checkIdCo, false, res[0].DISPONIBLE_CORREQUISITO, res[0].DISPONIBLE_MODALIDAD_CORREQUISITO);
        }
        if (checkIdCo === undefined){
          this.resetValuesSeccionHibrida();
        }
        this.resetValuesSeccionHibridaCo();

        if (res[0].RESP !== "OK")
         return funciones.showToast('w', res[0].RESP);

         funciones.showToast('w', res[0].RESP_CORREQUISITO);

       });
    }

  });

 });

}

countDown = ()=>{

  let time = this.state.closeTimeLE;
  
  this.count = setInterval(() => {
    time--;
    this.setState({ closeTimeLE: time < 0 ? 0 : time }, ()=>{
      if (time === -1){
        this.handleCloseListaEspera();
        return;
      }
    });
    
  }, 1000);

}

obtener_lista_espera = (cuenta)=>{

this.setState({ loadingLE: true }, ()=>{ 

 new Request
 .get(`${globales.ip}/matricula/lista_espera/${cuenta}/${tokenInfo.user}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 30000, deadline: 40000, }) 
 .end((err, res) => {
        
   if (err) { 

      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {
            
        window.location.reload();
        return;
              
      }

      this.setState({ rowsLE: [], countLE: 0, loadingLE: false }, ()=>{ 
        funciones.showToast('e', 'No hay conexión');
      });
        
      return;
   }
      
   const rows = JSON.parse(res.text);

   if (this.state.countLE !== rows.length){
     refreshOferta = true;
   }

   if (rows.length > 0) 
   {    
     this.setState({ rowsLE: rows, countLE: rows.length, loadingLE: false });
   }
   else 
   {
      this.setState({ rowsLE: [], countLE: 0, loadingLE: false });
   }            
   
 });

});

}

handleLE = ()=>{
this.setState({ openModalSeccionesLE: true });
}

handleCloseSeccionesLE = ()=>{
  this.setState({ openModalSeccionesLE: false }, ()=>{
    if (refreshOferta)
    this.setState({ loadingMain: true }, ()=>{
      this.obtener_oferta(this.cuenta);
    });
  });
}

onEnteringSeccionesLE = ()=> {

this.setState({ heightTableLE: funciones.getHeightTableDialog(movil, this.tablaLERef, this.dialogActionLERef, 3) }, ()=>{ 
  refreshOferta = false;
  if (!this.state.loadingLE)
  this.obtener_lista_espera(this.cuenta);
});

}

componentDidMount() { 

tokenInfo = Auth.getProfile(); //Token decodificado

this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{ 

 if (tokenInfo.plataforma === 1) // Usuario Admin
 {
   this.filtersClientes('-');
 }
 else if (tokenInfo.plataforma === 2) //Usuario estudiante
 {
   this.setState({ loadingClientes: false });
   this.handleChangeCuenta(null);       
 }

 this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }, ()=>{
   if (!movil && tokenInfo.plataforma === 1)
   document.getElementById('Est_Matricula').focus();
  }); 

}); 
               
}

componentWillUnmount() { 
  this.unsubscribeRows();
}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>    
                   <Autocomplete
                      id="Est_Matricula"
                      options={this.state.optionAutocomplete}
                      getOptionLabel={(option) => option.CUENTA_ALUMNO + ' - ' + option.NOMBRE_COMPLETO}
                      style={{ width: movil ? '100%' : '430px' }}
                      renderInput={(params) => <TextField {...params} 
                                                  label="Estudiante"
                                                  variant="outlined"
                                                  onBlur={this.onBlurAutoComplete}                                                                                                                         
                                                  InputProps={{
                                                              ...params.InputProps,
                                                              endAdornment: (
                                                             <React.Fragment>
                                                              {this.state.loadingClientes ? 
                                                              <Fade in style={{
                                                                transitionDelay: '1000ms',
                                                              }} unmountOnExit>
                                                              <CircularProgress size={18}/>
                                                              </Fade> 
                                                              : 
                                                               this.state.valueAutoComplete === null ?
                                                                <Tooltip title="Actualizar lista" placement="top">
                                                                <IconButton style={{ width: 23, height: 23 }} onClick={this.onRefresh}>
                                                                  <RefreshIcon color="primary"/>
                                                                </IconButton>
                                                                </Tooltip>
                                                               : null
                                                              }
                                                              {params.InputProps.endAdornment}
                                                              </React.Fragment>
                                                              ),
                                                            }}
                                                  fullWidth
                                                 />}
                      renderOption={RenderOption}                              
                      onChange={this.onChangeAutocomplete}
                      open={this.state.openAutoComplete}
                      loading = {this.state.loadingClientes}
                      ListboxComponent={virtual.ListboxComponent}
                      value={this.state.valueAutoComplete} 
                      className={classes.textField}
                      disableClearable={this.state.loadingMain}
                      onInputChange={this.onChangeInput}
                      popupIcon={null}
                      PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                              
                       />           
                      <Select Label='Modalidad de pago'
                              Datos = {this.state.datosSelectModPago} 
                              Selected= {this.state.selectedModPago}
                              onChange={this.handleChangeModPago}
                              Style = {classes.formControlSelect}                                  
                              Outlined                            
                              />                   
                   </div>
                </React.Fragment>
              );

             }
             else if (tokenInfo.plataforma === 2) //Si es Usuario Estudiante
             {

              return (
                <React.Fragment >
                  <div  className={classes.container}>
                   <Select Label='Modalidad de pago'
                           Datos = {this.state.datosSelectModPago} 
                           Selected= {this.state.selectedModPago}
                           onChange={this.handleChangeModPago}
                           Style = {classes.formControlSelect}                                  
                           Outlined                            
                           />  
                  </div>
                </React.Fragment>
                  );

             }             
             
            })()

          }

          <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
           <CustomTable 
            Columns={columns} 
            Rows={this.state.rows}
            Grouping={grouping}                      
            TableColumnExtensions={columnExtensions} 
            DefaultHiddenColumnNames={['ID_SECCION', 'ID_PLAN', 'ESTATUS_FINANCIERO', 'GRUPO', 'OPTATIVA', 'TREE']}
            ExpandedGroups={this.state.expandedGroups}
            ChangeExpandedGroups = {this.changeExpandedGroups}
            groupContentComponent={GroupCellContent}
            getRowId={RowId}
            rowHeaderCellComponent={HeaderRowCellComponent(this.state.valueAutoComplete, this.handleResumen, this.handleLE, this.handleDetalle, this.state.countLE)}
            VirtualTable_cellComponent={VirtualTable_cellComponent(classes.tooltip)}
            height={this.state.heightTableMain} 
            loading={this.state.loadingMain} 
            enabledFilterRows
            filterCellComponent={FilterCellComponent}
            TableNameTreeColum='ROOT_TREE'
            GetChildRows={ChildRows}
            showSelectionControlsTree
            OnExpandedRowIdsChange = {this.changeExpandedRowIds}
            ExpandedRowIds={this.state.expandedRowIds}
            TableTreeColumn_cellComponent= {TableTreeColumn_cellComponent(this.state.loadingCheck, checkId)}
            leftColumnsFixed={['ROOT_TREE']}
            columnFixedCellComponent = {ColumnFixed_cellComponent(classes, this.handleChangeCheckFilter, this.state.filterCheck)}
            FilteringColumnExtensions = {this.settingFilter}
            Filters = {this.state.filters} 
            onFiltersChange={this.changeFilters}
            Selection ={this.state.selection}
            ChangeSelection={this.changeSelection}
            columnWidths={columnExtensions}
            />                  
            </div>
            
            <Dialog open= {this.state.openModalCorrequsito}                            
                    TransitionProps={{ onEntering: this.onEnteringCorrequisito }} 
                    classes={{ paper: classes.paperCorrequisito }}
                    fullScreen={movil}>
            <DialogTitle><Typography component='span' variant='subtitle2'>Correquisito</Typography>
              <IconButton className={classes.closeButton} onClick={this.handleCloseCorrequisito} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
             </DialogTitle>
             <DialogContent style={{ paddingBottom: !movil ? '0px' : '5px' }}>
             <div ref={this.tablaCorreqRef} className="disableTouchOptions">
              <CustomTable 
                Columns={columnsCorreq} 
                Rows={this.state.rowsCorreq}
                DefaultHiddenColumnNames={['ID_SECCION']}
                loading={this.state.loadingCorreq}
                height = {this.state.heightTableCorreq}
                getRowId={RowId} 
                showSelectionColumn
                VirtualTable_cellComponent={VirtualTable_cellComponent(classes.tooltip)}
                TableColumnExtensions={columnExtensionsCorreq} 
                columnWidths={columnExtensionsCorreq} 
                leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
                tableSelectionCellComponent= {TableSelectionCellComponent(this.state.loadingCheck, checkIdCo, this.state.disabledChecksCo)}
                Selection ={this.state.selectionCorreq}
                ChangeSelection = {this.changeSelectionCorreq}
                columnFixedCellComponent = {ColumnFixed_cellComponent(classes, null, null)}
              /> 
              </div>
             </ DialogContent>
             <DialogActions ref={this.dialogActionRef} />
             </Dialog>
             
             <Dialog open= {this.state.openModalDetalle}                            
                     TransitionProps={{ onEntering: this.onEnteringDetalle }} 
                     classes = {{ paper: classes.paperDetalle }}
                     fullScreen={movil}
                    >
            <DialogTitle><Typography component='span' variant='subtitle2'>Detalle de cuotas</Typography>
              <IconButton className={classes.closeButton} onClick={this.handleCloseDetalle} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
             </DialogTitle>
            <DialogContent style={{ paddingBottom: '0px'}}>
            <div ref={this.tablaDetalleRef} className="disableTouchOptions">
              <CustomTable 
                Columns={columnsDetalle} 
                Rows={this.state.rowsDetalle}                
                loading={this.state.loadingDetalle}
                height = {this.state.heightTableDetalle}                
                VirtualTable_cellComponent={VirtualTableDetalle_cellComponent}
                TableColumnExtensions={columnExtensionsDetalle}
              /> 
              </div>
            </ DialogContent>
            <DialogActions ref={this.dialogActionDetalleRef} />
            </Dialog>

             <Dialog open= {this.state.openBackDrop ? false : this.state.openModalListaEspera}
                     TransitionProps={{ onEntered: this.countDown }} 
                     classes ={{ paper: classes.paperListaEspera}}>
              <DialogTitle><Typography component='span' variant='subtitle2'>Inscripción</Typography>
                 <span className={classes.labelTime}>{"(" + this.state.closeTimeLE + ")"}</span>
                 <IconButton className={classes.closeButton} onClick={this.handleCloseListaEspera} size="small">
                  <CloseIcon fontSize="small" />
                 </IconButton>
               </DialogTitle>
               <DialogContent style={{ paddingTop: "20px" }}>
                <Typography variant="body1" gutterBottom style={{ textAlign: "justify", textJustify: "inter-word" }}>                
                 {this.state.messageLE}
                 </Typography>   
                </DialogContent>                       
                <DialogActions style={{ marginTop: '20px', paddingLeft: 0, paddingRight: 0}}>
                  <BarraBotones botones={this.state.showButtomsDirLE ? this.botones_lista_espera_dir : this.botones_lista_espera} />
                </DialogActions>
                </Dialog>

                <Dialog open= {this.state.openModalHibrida}
                        classes ={{ paper: classes.paperListaEspera}}>
                <DialogTitle><Typography component='span' variant='subtitle2'>{this.state.titleModalHibrida}</Typography>
                 <IconButton className={classes.closeButton} onClick={this.handleCloseHibrida} size="small">
                  <CloseIcon fontSize="small" />
                 </IconButton>
                </DialogTitle>
                <DialogContent style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                <List className={classes.root}>
                <ListItem alignItems="flex-start" button onClick={this.onClickListItem("PRE")}> 
                  <ListItemAvatar>
                   <Avatar>
                     <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Presencial"
                    secondary={"Grupo convencional, deberá presentarse al aula de clases especificada. (" + this.state.cuposHibridaA + " cupo(s) disponibles)"}
                    />
                </ListItem>
                <Divider variant="inset" component="li" />
                <ListItem alignItems="flex-start" button onClick={this.onClickListItem("PMV")}> 
                  <ListItemAvatar>
                   <Avatar>
                     <VideocamIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary="Por Videoconferencia"
                    secondary={"Grupo que permite interactuar en la clase mediante video conferencia. (" + this.state.cuposHibridaB + " cupo(s) disponibles)"}
                    />
                </ListItem>
                </List>
               </DialogContent>                       
               </Dialog>

               <Dialog open= {this.state.openModalSeccionesLE}                            
                       TransitionProps={{ onEntering: this.onEnteringSeccionesLE }} 
                       classes = {{ paper: classes.paperCorrequisito }}
                       fullScreen={movil}
                    >
              <DialogTitle><Typography component='span' variant='subtitle2'>Secciones en lista de espera</Typography>
                <IconButton className={classes.closeButton} onClick={this.handleCloseSeccionesLE} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </DialogTitle>
              <DialogContent style={{ paddingBottom: '0px' }}>
              <div ref={this.tablaLERef} className="disableTouchOptions">
                <CustomTable 
                  Columns={columnsLE} 
                  Rows={this.state.rowsLE}                
                  loading={this.state.loadingLE}
                  height = {this.state.heightTableLE}                
                  VirtualTable_cellComponent={VirtualTable_cellComponent(classes.tooltip)}
                  TableColumnExtensions={columnExtensionsLE} 
                /> 
                </div>
              </ DialogContent>
              <DialogActions ref={this.dialogActionLERef} />
              </Dialog>

                <Reporte label_reporte="RESUMEN_MATRICULA" 
                         id="BTRM"
                         parametros={tokenInfo.plataforma !== 2 ? this.cuenta : tokenInfo.user} 
                         nom_boton="" 
                         nom_bar="Resumen Matrícula"  
                         fill="white"
                         fullScreen
                         boton={false} 
                         opciones={false}
                         color_bar='primary'/>

                <Backdrop className={classes.backdrop} 
                          open={this.state.openBackDrop} 
                          transitionDuration={this.state.transitionDurationBackdrop}>                                       
                  <CircularProgress color="inherit" />
                  <span style={{ marginTop: '10px' }}>{this.state.messageBackdrop}</span>
                </Backdrop>
                <Backdrop open={this.state.openBackDropInvisible || this.state.loadingMain || this.state.loadingClientes || this.state.loadingCheck || this.state.loadingCorreq || this.state.loadingDetalle || (this.state.loadingLE && this.state.openModalSeccionesLE)}
                          className={classes.backdrop} 
                          invisible 
                          transitionDuration={0}/>
          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)